module.exports = __webpack_public_path__ + "images/183_640.jpg";